module.exports = __webpack_public_path__ + "static/vr-tubes-87ec44ec240a5fd3e36e7512d3515960.png";